import Vue from 'vue'

const resource = 'documentation'

// ユーザータイプをAPI用の文字列に変換
const getUserTypeString = (userType) => {
  // USER_TYPE_PATIENT = 0 → 'patient'
  // USER_TYPE_PHARMACIST = 1 → 'pharmacist'
  return userType === 1 ? 'pharmacist' : 'patient'
}

// メニュー一覧を取得（新しいAPI）
const getManualList = (userType) => {
  return Vue.axios.get(`${resource}/menu`, {
    headers: {
      'X-User-Type': getUserTypeString(userType)
    }
  })
}

// FileIDを指定してダウンロード
const downloadFile = (fileId, userType) => {
  return Vue.axios.get(`${resource}/files/${fileId}/download`, {
    headers: {
      'X-User-Type': getUserTypeString(userType),
      'Accept': '*/*' // バイナリ形式で取得するため、JSONを要求しない
    },
    responseType: 'blob'
  })
}

export default {
  getManualList,
  downloadFile
}



// WEBPACK FOOTER //
// ./src/api/documentation.js